module.exports = __webpack_public_path__ + "img/recieptReview-mobile.0fa69d54.png";